import { BranchOffice } from '../models/interfaces/branch-office';
import { BranchOfficeModel } from '../models/branch-office.model';
import { BranchOfficeForm } from '../models/interfaces/forms/branch-office.form';

export function toBranchOfficeModel(data: BranchOffice): BranchOfficeModel {
  let response = new BranchOfficeModel();
  response.id = data.id;
  response.name = data.nombre;
  response.address = data.direccion;
  response.phone = data.telefono;
  response.type = data.tipo;
  response.cashiers = data.cajas;
  return response;
}

export function toBranchOfficeModelCollection(collection: BranchOffice[]): BranchOfficeModel[] {
  let response = new Array<BranchOfficeModel>();
  for (let branchOffice of collection) {
    response.push(toBranchOfficeModel(branchOffice));
  }
  return response;
}

export function toBranchOfficeRequestDTO(branchOffice: BranchOfficeForm): BranchOffice {
  let response = <BranchOffice>{};

  if (branchOffice.id) {
    response.id = branchOffice.id;
  }
  response.nombre = branchOffice.name;
  response.direccion = branchOffice.address;
  response.telefono = branchOffice.phone;

  response.ubicacion = {
    id: branchOffice.branchId,
    latitud: branchOffice.latitud,
    longitud: branchOffice.longitud,
    nombreDireccion: branchOffice.address,
    placeId: branchOffice.placeId,
    ciudad: branchOffice.ciudadControl,
    codigoPostal: branchOffice.cpControl,
    descripcion: '',
    piso: branchOffice.pisoControl,
    departamento: branchOffice.dptoControl,
    provincia: branchOffice.provinciaControl,
    esDepartamento: branchOffice.esDepartamento || false,
    pais: branchOffice.pais,
    calle: branchOffice.calleControl,
    altura: branchOffice.numeroControl,
    municipalidad: '',
    region: ''
  };

  return response;
}
